import type { ColumnFiltersState, SortingState } from '@tanstack/react-table';

export interface ILegacySortItem {
    field: string;
    sort: 'asc' | 'desc' | null;
}
export type TLegacySortModel = ILegacySortItem[];

export const legacySortModelToSortingState = (model?: TLegacySortModel): SortingState =>
    (model ?? [])
        .filter((item): item is ILegacySortItem & { sort: 'asc' | 'desc' } => !!item.sort)
        .map((item) => ({ id: item.field, desc: item.sort === 'desc' }));

export const sortingStateToLegacySortModel = (sorting: SortingState): TLegacySortModel =>
    sorting.map((s) => ({ field: s.id, sort: s.desc ? 'desc' : 'asc' }));

export interface ILegacyFilterItem {
    id?: string | number;
    columnField: string;
    operatorValue?: string;
    value?: any;
}
export interface ILegacyFilterModel {
    items: ILegacyFilterItem[];
    linkOperator?: 'and' | 'or';
}

export const columnFiltersToLegacyFilterModel = (filters: ColumnFiltersState): ILegacyFilterModel => ({
    items: filters.map((filter, index) => ({
        id: index,
        columnField: filter.id,
        operatorValue: (filter.value as any)?.operator ?? 'contains',
        value: (filter.value as any)?.value,
    })),

});